import { z } from "zod";

const schema = z.object({
  VITE_API_URL: z.union([z.literal(""), z.string().url()]).default("http://localhost:4000"),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  throw new Error(`Invalid VITE env: ${JSON.stringify(parsed.error.flatten().fieldErrors)}`);
}

export const env = parsed.data;
